// extracted by mini-css-extract-plugin
export default {"form":"AddReminderModal_form__y6gKH"};